import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

import StepForm from '../../../../../../features/components/Forms/StepForm'
import MarginFeeStep from '../../Steps/MarginFeeStep'
import AllCampaignsMarginStep from '../../Steps/AllCampaignsMarginStep'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'

import { keys } from '../../../../../../helpers/common'
import { calculateMargins } from '../../Steps/MarginFields/formatters'

import { createMargins, clearCreateMargins } from '../../../../../../modules/actions/margins'
import {
  createMarginsErrorSelector,
  createMarginsIsLoadingSelector,
  createMarginsWasCreatedSelector
} from '../../../../../../modules/selectors/margins'
import { selectedPartnershipIdSelector } from '../../../../../../modules/selectors/partnerships'

import { initialValues } from '../../fields'
import { validationSchema } from './validation'
import { MARGIN_CREATE } from '../../../../../../constants/forms'

const MarginRoute = ({ formatOption, FormRouteSelector, eventSourceStep, ...formProps }) => {
  const dispatch = useDispatch()

  const marginsWasCreated = useSelector(createMarginsWasCreatedSelector)
  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)

  const onSubmit = useCallback(
    values => {
      const calculatedMargins = calculateMargins(values)
      const margins = keys(calculatedMargins).map(platform => ({
        partnership: selectedPartnershipId,
        provider: platform,
        margin: calculatedMargins[platform]
      }))

      dispatch(createMargins(margins))
    },
    [dispatch, selectedPartnershipId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)
  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: <AllCampaignsMarginStep />,
        show: true
      },
      {
        component: <MarginFeeStep />,
        show: true
      }
    ],
    [FormRouteSelector]
  )

  const clearCreateMarginHandler = () => {
    dispatch(clearCreateMargins())
  }

  return (
    <StepForm
      steps={steps}
      formik={purifiedFormik}
      formName={MARGIN_CREATE}
      {...formProps}
      // this allow to clearCreateMargins on error
      clearSubmitHandler={clearCreateMarginHandler}
      successSubmit={marginsWasCreated}
      errorSelector={createMarginsErrorSelector}
      isLoadingSelector={createMarginsIsLoadingSelector}
    />
  )
}

export default MarginRoute
